import { render } from "./ProductKeywordsModal.vue?vue&type=template&id=58eb0da4&scoped=true"
import script from "./ProductKeywordsModal.vue?vue&type=script&lang=js"
export * from "./ProductKeywordsModal.vue?vue&type=script&lang=js"

import "./ProductKeywordsModal.vue?vue&type=style&index=0&id=58eb0da4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58eb0da4"]])

export default __exports__